var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "74px",
    viewBox: "0 0 80 74",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "n-check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uq-confirmation-page",
    transform: "translate(-800.000000, -167.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "n-check",
    transform: "translate(800.000000, 167.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.9080117,25.355963 C71.2394347,28.9929259 71.9688109,32.9135556 71.9688109,37 C71.9688109,55.8905556 56.447076,71.2592593 37.3684211,71.2592593 C18.2897661,71.2592593 2.76803119,55.8905556 2.76803119,37 C2.76803119,18.1094444 18.2897661,2.74074074 37.3684211,2.74074074 C45.2337817,2.74074074 52.4915595,5.35814815 58.309961,9.75292593 L60.4219688,7.91251852 C54.0665692,2.96274074 46.062807,0 37.3684211,0 C16.7631969,0 0,16.5979259 0,37 C0,57.4020741 16.7631969,74 37.3684211,74 C57.9736452,74 74.7368421,57.4020741 74.7368421,37 C74.7368421,32.1187407 73.7680312,27.4581111 72.0255556,23.1866667 L69.9080117,25.355963 Z",
    id: "Path",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#8CC170",
    points: "74.4497608 2.11428571 39.7607656 32.4190476 24.4976077 21.3991342 18.9473684 26.9090909 39.7607656 47.5714286 80 6.24675325"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderCheck);
export default __webpack_public_path__ + "static/media/order-check.f6fb70f112acfcc6d590e7b0b8976a49.svg";
export { ForwardRef as ReactComponent };